<template>
  <div class="nuttrema-abc-button">
    <el-button :type="type" size="mini" @click="toggleState">{{ title }}</el-button>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-abc-button',
  props: {
    title: {
      type: String,
      required: false,
      default: 'abc',
    },
    showFilterByFirstLetter: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      on: false,
    };
  },
  computed: {
    type() {
      return this.on ? 'primary' : 'gray';
    },
  },
  methods: {
    toggleState() {
      this.on = !this.on;
      this.$emit('show', this.on);
    },
  },
  created() {
    this.on = this.showFilterByFirstLetter;
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .el-button--gray {
    background-color: $gray-lighter;
    border-color: $gray-lighter;
  }

  .nuttrema-abc-button {
    display: flex;
    flex-shrink: 0;
    padding-right: 0.5em;

    /deep/ .el-button {
      padding: 3px 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-abc-button.vue